










































import { Component, Mixins, Prop } from 'vue-property-decorator';
import moment from 'moment';
import filesaver from 'file-saver';
import MyList from '@/mixins/list';

@Component
export default class extends Mixins(MyList) {
    @Prop() listParams: any

    columns: any[] = [
      { title: '头像', scopedSlots: { customRender: 'avatar' } },
      { title: '用户', scopedSlots: { customRender: 'username' } },
      { title: '场馆', dataIndex: 'stadium_name' },
      { title: '时间', dataIndex: 'created_time' },
      { title: '金额', scopedSlots: { customRender: 'fee' } },
      { title: '描述', dataIndex: 'payment_desc' },
      { title: '微信交易单号', dataIndex: 'transaction_id' },
    ]

    mounted() {
      this.loadDetailList();
    }

    async loadDetailList() {
    //   console.log(this.listParams);
      this.loading = true;
      const res = await this.$store.dispatch('bi/rowDetailList', {
        ...this.listParams,
      });

      this.loading = false;

      if (res && res.Data) {
        this.data = res.Data;
      }
    }

    async exportExcel() {
      this.$confirm({
        title: '确认信息',
        content: '确认导出吗？',
        onOk: async () => {
          const res = await this.$store.dispatch('bi/exportRowDetailList', {
            ...this.listParams,
          });
          // console.log(res)
          if (res && res.data) {
            const blob = new Blob([res.data], {
              type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            filesaver.saveAs(
              blob,
              `对账月报单项明细-${moment().format('YYYY-MM-DD HH:mm:ss')}.xlsx`,
            );
          }
        },
      });
    }
}
